import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";


import { FaUserSlash } from "react-icons/fa";
// Import Font Awesome
// For Solid Icon
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faStar,
    faUsers,
    faCircleCheck,
    faUser,
    faCog,
    faWallet,
    faEnvelope,

} from "@fortawesome/free-solid-svg-icons";

import TopHeader from "../../components/comman/TopHeader";
import Sidebar from "../../components/comman/Sidebar";

import { logout, getCurrentUserId } from "../../utils/auth";
import { profileApi } from "../../api/profileApi";
import { getSidebarMenus } from "../../constants/sidebarMenus";

import "../../css/User/Kyc.css";
import "../../css/User/BlockedList.css";


function BlockedList() {
    const navigate = useNavigate();
    const currentUserId = getCurrentUserId();

    const BASE_URL = process.env.REACT_APP_BASE_URL;

    // Check it's Owner Or not
    // const isOwner = currentUserId === post.user._id;
    // For navigation
    // const profileLink = isOwner ? `/my/${post.user._id}/profile` : `/user/${post.user._id}/profile`;
    const profileLink = "";

    const [showSidebar, setShowSidebar] = useState(true);
    const [activeSidebar, setActiveSidebar] = useState("blocked");

    const [blockedUsers, setBlockedUsers] = useState([]);
    const [loading, setLoading] = useState(false);

    // Determine feed type based on active sidebar
    const feedTYPE = window.location.pathname.includes("/feed/public") ? "public" : "prime";
    const [feedType, setFeedType] = useState(feedTYPE);

    // for message drawer
    const [showMsgDrawer, setShowMsgDrawer] = useState(false);

    /* ================= LOGOUT ================= */
    const handleLogout = () => {
        logout();
        navigate("/login", { replace: true });
    };

    /* ================= FETCH BLOCKED USERS ================= */
    const fetchBlockedUsers = async () => {
        try {
            setLoading(true);
            const res = await profileApi.getBlockedUsers();
            setBlockedUsers(res?.blockedUsers || []);
        } catch (err) {
            toast.error("Failed to load blocked users");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchBlockedUsers();
    }, []);

    /* ================= UNBLOCK USER ================= */
    const handleUnblock = async (userId) => {
        try {
            await profileApi.unblockUser(userId);

            toast.success("User unblocked");

            // remove from UI instantly
            setBlockedUsers(prev =>
                prev.filter(user => user._id !== userId)
            );
        } catch (err) {
            toast.error("Failed to unblock user");
        }
    };

    /* ================= SIDEBAR MENUS ================= */
    const sidebarMenus = getSidebarMenus(currentUserId);


    //////////////////////////////////////////////////////
    return (
        <div className="container-xxl p-0">
            <div className="feed-page-wrapper">
                <TopHeader
                    onToggleSidebar={() => setShowSidebar(prev => !prev)}
                    onOpenMessages={() => setShowMsgDrawer(true)}
                    creditAmount={50}
                    notificationCount={5}
                    messageCount={0}
                />
                <div className="prime-layout-container .container-fluid">
                    <div className="row">
                        {!showSidebar && (
                            <div
                                className="left-sidebar-overlay d-md-none"
                                onClick={() => setShowSidebar(true)}
                            />
                        )}

                        <Sidebar
                            showSidebar={showSidebar}
                            sidebarMenus={sidebarMenus}
                            activeSidebar={activeSidebar}
                            feedType={feedType}
                            // onNavigate={(item) => navigate(item.path)}
                            onNavigate={(item) => {
                                setActiveSidebar(item.key); // MAIN LINE (orange highlight fix)
                                if (item.path) {
                                    navigate(item.path);
                                }
                            }}
                            onLogout={handleLogout}
                        />


                        {/* ================= CENTER AREA ================= */}
                        <div className="col-lg-9 col-md-9 col-12 overflow-auto center-area-container">
                            {/* ================= CENTER AREA START ================= */}
                            {/* ================= BLOCKED USER PAGE START ================= */}
                            <div className="col-12 d-flex justify-content-center">
                                <div className="col-12 col-sm-11 p-3 shadow-sm rounded-3 block-list-container">
                                    {blockedUsers.length !== 0 && 
                                        <h4 className="mb-4">Blocked Users</h4>
                                    }

                                    {loading && (
                                        <div className="text-center py-4">
                                            Loading...
                                        </div>
                                    )}

                                    {!loading && blockedUsers.length === 0 && (
                                        <div className="d-flex justify-content-center align-items-center w-100 h-100">
                                            <div className="text-center py-5 text-muted">
                                                <FaUserSlash size={40} className="mb-2" />
                                                <p>No blocked users</p>
                                            </div>
                                        </div>
                                    )}

                                    {/* ===== BLOCKED USER LIST ===== */}
                                    <div className="list-group pb-3">
                                        <div className="row g-2">
                                            {blockedUsers.map(user => (
                                                <div className="col-12 col-lg-6" key={user._id}>

                                                    <div
                                                        className="w-100 list-group-item d-flex align-items-center justify-content-between rounded-3"
                                                    >
                                                        <Link to={`/user/${user._id}/profile`} className="text-decoration-none text-body navigation-link">
                                                            <div className="d-flex align-items-center gap-3">
                                                                <div className="user-profile-img-box">
                                                                    <img
                                                                        src={
                                                                            user.profilePic
                                                                                ? `${user.profilePic}`
                                                                                : "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                                                                        }
                                                                        alt={user.fullName}
                                                                        className="profile-img"
                                                                        onError={(e) => {
                                                                            e.target.src =
                                                                                "https://cdn-icons-png.flaticon.com/512/149/149071.png";
                                                                        }}
                                                                    />
                                                                </div>

                                                                <div>
                                                                    <h6 className="mb-0">{user.fullName}</h6>
                                                                    <small className="text-muted">
                                                                        {user.role}
                                                                    </small>
                                                                </div>
                                                            </div>
                                                        </Link>

                                                        <button
                                                            className="btn btn-outline-danger btn-sm"
                                                            onClick={() => handleUnblock(user._id)}
                                                        >
                                                            Unblock
                                                        </button>
                                                    </div>

                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                    {/* ===== END LIST ===== */}
                                </div>
                            </div>
                            {/* ================= BLOCKED USER PAGE END ================= */}
                            {/* </div> */}
                        </div>

                    </div>
                </div>
            </div>

            {/* =========== MESSAGE DRAWER START =========== */}
            {/* Msg Drawer */}
            {
                showMsgDrawer && (
                    <>
                        <div
                            className="msg-overlay"
                            onClick={() => setShowMsgDrawer(false)}
                        ></div>

                        <div className="msg-drawer">
                            <div className="msg-header">
                                <h3>Chats</h3>
                                <span onClick={() => setShowMsgDrawer(false)}>✕</span>
                            </div>

                            <div className="msg-search">
                                <input placeholder="Search Messenger" />
                            </div>

                            <div className="msg-tabs">
                                <span className="active">All</span>
                                <span>Unread</span>
                                <span>Groups</span>
                                <span>Communities</span>
                            </div>

                            <div className="msg-empty">
                                <h4>No chats</h4>
                                <p>When you have chats, you’ll see them here.</p>
                            </div>

                            <div
                                className="msg-footer"
                                onClick={() => {
                                    setShowMsgDrawer(false);
                                    // navigate("/message");
                                    navigate("/message");
                                }}
                            >
                                See all in Messenger
                            </div>
                        </div>
                    </>
                )
            }
            {/* =========== MESSAGE DRAWER END =========== */}
        </div>
    );
}

export default BlockedList;
